// // src/pages/HomePage.jsx

// import React, { useEffect } from 'react';
// import { useLocation } from 'react-router-dom';
// import HeroSection from '../components/HeroSection';
// import FeaturesGrid from '../components/FeaturesGrid';
// import HowToGetStarted from '../components/HowToGetStarted';
// import EnterSchoolId from '../components/EnterSchoolId';

// const HomePage = () => {
//   const location = useLocation();

//   // Lets "See what's included" (and any /#features link) scroll to the
//   // features section, whether you're already on the homepage or arriving
//   // from another route.
//   useEffect(() => {
//     if (location.hash) {
//       const target = document.querySelector(location.hash);
//       if (target) {
//         requestAnimationFrame(() => target.scrollIntoView({ behavior: 'smooth' }));
//       }
//     }
//   }, [location]);

//   return (
//     <div className="bg-white text-[#101826] min-h-screen flex flex-col">
//       <EnterSchoolId />
//       <HeroSection />
//       <FeaturesGrid />
//       <HowToGetStarted />
//     </div>
//   );
// };

// export default HomePage;


// src/pages/HomePage.jsx

import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import HeroSection from '../components/HeroSection';
import EnterSchoolId from '../components/EnterSchoolId';
import AboutSection from '../components/AboutSection';
import FeaturesGrid from '../components/FeaturesGrid';
import HowToGetStarted from '../components/HowToGetStarted';

const HomePage = () => {
  const location = useLocation();

  // Lets any /#anchor link (find-school, about, facility) scroll to the
  // right section, whether you're already on the homepage or arriving
  // from another route.
  useEffect(() => {
    if (location.hash) {
      const target = document.querySelector(location.hash);
      if (target) {
        requestAnimationFrame(() => target.scrollIntoView({ behavior: 'smooth' }));
      }
    }
  }, [location]);

  return (
    <div className="bg-white text-[#101826] min-h-screen flex flex-col">
      <HeroSection />
      <EnterSchoolId />
     
      <FeaturesGrid />
      <HowToGetStarted />
      <AboutSection />
    </div>
  );
};

export default HomePage;
